module.exports = __webpack_public_path__ + "static/sharpshooters-oath-a2b050ab8ba9350e507e9947660f4bae.png";